import {
    REQUEST_STATE,

    CORE_GET_ALL_TRANSFERS_REQUEST,
    CORE_GET_ALL_TRANSFERS_SUCCESS,
    CORE_GET_ALL_TRANSFERS_FAILURE,

    CORE_GET_TRANSFER_BY_ID_REQUEST,
    CORE_GET_TRANSFER_BY_ID_SUCCESS,
    CORE_GET_TRANSFER_BY_ID_FAILURE,

} from '../types'

const requestState = REQUEST_STATE

export default {
    transfers: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_TRANSFERS_REQUEST:
                return state
            case CORE_GET_ALL_TRANSFERS_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_GET_ALL_TRANSFERS_FAILURE:
                return []
            default:
                return state
        }
    },
    transfer: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_TRANSFER_BY_ID_REQUEST:
                return state
            case CORE_GET_TRANSFER_BY_ID_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_GET_TRANSFER_BY_ID_FAILURE:
                return {}
            default:
                return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/transfer.js